'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import useQuery from '../hooks/useQuery';
import themes from './themes';
import { isThemingEnabled } from './operators/isThemingEnabled';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

var getTheme = function getTheme() {
  var stateTheme = useSelector(function (state) {
    return state.theming.theme;
  });
  var queryTheme = useQuery().theme;
  var theme = queryTheme || stateTheme;
  return isThemingEnabled() ? themes[theme] : themes['defaultTheme'];
};

export var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children;
  var theme = getTheme();
  return /*#__PURE__*/_jsx(StyledThemeProvider, {
    theme: theme,
    children: children
  });
};